import { render, staticRenderFns } from "./ArgInputContact.vue?vue&type=template&id=6eb9fd84"
import script from "./ArgInputContact.vue?vue&type=script&lang=ts"
export * from "./ArgInputContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports